import IconButton from '@mui/material/IconButton';
import React from 'react';
import { CgSpinner } from 'react-icons/cg';
import { MdOutlineFileDownload } from 'react-icons/md';
import { toast } from 'react-toastify';

import { RequirementControlAtom } from '@/state/RequirementControl.atom';

import api from '../../services/apiSgft';
import LightTooltip from '../atoms/LightTooltip';

interface RequirementControlDownloadButtonProps {
	filteredData: RequirementControlAtom;
}

export const RequirementControlDownloadButton: React.FC<
	RequirementControlDownloadButtonProps
> = ({ filteredData }) => {
	const [loading, setLoading] = React.useState(false);

	async function download() {
		setLoading(true);
		try {
			const response = await api.get(`/extraction/requirement-control`, {
				params: {
					employee: filteredData.employee,
					role: filteredData.role,
					management: filteredData.management,
					areaCoordinator: filteredData.areaCoordinator,
					pole: filteredData.pole,
					workstation: filteredData.workstation,
					status: filteredData.status,
					situation: filteredData.situation,
					requirementType: filteredData.requirementType,
					requirement: filteredData.requirement,
				},
				responseType: 'blob',
			});
			const url = window.URL.createObjectURL(
				new Blob([response.data], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				}),
			);
			const link = document.createElement('a');

			link.href = url;
			link.setAttribute('download', 'Controle de Requisitos - SGFT.xlsx');
			document.body.appendChild(link);
			link.click();
			link.remove();
		} catch (e) {
			toast.error('Estrutura sem dados', {
				theme: 'colored',
				toastId: 'error',
			});
			throw e;
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="cursor-pointer">
			<LightTooltip title="Extrair Controle de Requisitos">
				<IconButton onClick={download} disabled={loading}>
					{loading ? (
						<CgSpinner
							size={30}
							color="#c1c1c1"
							className="h-full animate-spin"
						/>
					) : (
						<MdOutlineFileDownload />
					)}
				</IconButton>
			</LightTooltip>
		</div>
	);
};
